// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"styles_contentContainer__1RLjN","favorites":"styles_favorites__2u98r"};